export default __webpack_public_path__ + "static/media/viciousstrike2.a91e7256.png";